/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Refunds__TitleInputs */

const en_help_center__refund_policy__refunds__title = /** @type {(inputs: Help_Center__Refund_Policy__Refunds__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund Processing`)
};

/**
* | output |
* | --- |
* | "Refund Processing" |
*
* @param {Help_Center__Refund_Policy__Refunds__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__refunds__title = /** @type {((inputs?: Help_Center__Refund_Policy__Refunds__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Refunds__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__refund_policy__refunds__title(inputs)
});